import { render, staticRenderFns } from "./sociallogin.vue?vue&type=template&id=6ffb2652&scoped=true&"
import script from "./sociallogin.vue?vue&type=script&lang=js&"
export * from "./sociallogin.vue?vue&type=script&lang=js&"
import style0 from "./sociallogin.vue?vue&type=style&index=0&id=6ffb2652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb2652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDialog,VIcon,VLayout,VProgressCircular,VRow})
